import React from 'react';
import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';

let BotonesGuardado = React.createClass({

    guardar: function () {
        this.props.guardar(this.props.cerrarModal, this.props.guardaDatos);

        let estado = {
            'empresas': this.props.data.empresas,
            'empresasNoModificadas': this.props.data.empresasNoModificadas,
            'cuentas': this.props.data.cuentas,
            'cuentasNoModificadas': this.props.data.cuentasNoModificadas,
            'tarjetas': this.props.data.tarjetas,
            'novedadesEmpresas': this.props.data.novedadesEmpresas,
            'novedadesCuentas': this.props.data.novedadesCuentas,
            'novedadesTarjetas': this.props.data.novedadesTarjetas
        }

        this.props.actualizarEstadoPantallaInvocadora(estado);
    },

    cancelar: function () {
        this.props.cancelar(this.props.cerrarModal);
    },

    render: function () {
        let imgError = null;
        let edicionActiva = undefined;
        let btnAceptar = <GenericSimpleButton text="Aceptar" id="botonAceptar" buttonClass="btn btn-cta" onClick={() => this.guardar()} />;

        if (this.props.data.limiteEmpresaExcedido !== undefined && this.props.data.limiteEmpresaExcedido.excede ||
            this.props.data.limiteCuentaExcedido !== undefined && this.props.data.limiteCuentaExcedido.excede ||
            this.props.data.limiteTarjetasExcedido !== undefined && this.props.data.limiteTarjetasExcedido.excede) {
            imgError =
                <div>
                    <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                </div>

            if (this.props.guardaDatos){
                btnAceptar = <GenericSimpleButton text="Aceptar" id="botonAceptar" buttonClass="btn btn-secondary btn-cta" />
                edicionActiva = <label>Debe distribuir correctamente los limites.</label>
            }
        }

        if (this.props.abrirModalEstaEditando) {
            edicionActiva = <label>Debe finalizar la edición antes de continuar.</label>
        } 

        return (
            <div className="row">
                {(this.props.data.readyRequest == true) ?
                    <div className="col-md-4">
                        <GenericSimpleIconButton text="Guardado en proceso... " buttonClass="btn btn-cta disabled" iconClass="fa fa-circle-o-notch fa-spin" />
                    </div> :
                    <div>
                        <div className="col-md-2">
                            <div className="row">
                                <div className="col-md-8">
                                    {btnAceptar}
                                </div>
                                <div className="col-md-4">
                                    {imgError}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => this.cancelar()} />
                        </div>
                    </div>}
                <div className="col-md-8">
                    {edicionActiva}
                </div>
            </div>
        );
    }
});

export default BotonesGuardado